export const PREFUND_URL = 'https://venom-sdk-backend-production.up.railway.app/prefund';
export const PARTNER_SITES = {
  'venomart.io': 'https://venomart.io/launchpad/custom/biovenomsdk',
  'bivenomsdk.com': 'https://bivenomsdk.com/launchpad/custom/biovenomsdk',
};
// export const PREFUND_URL='http://localhost:3001/prefund'
